"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTooltip = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require("reactackle-core");

var _Tooltip = require("./Tooltip");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipWrapper = require("./TooltipWrapper");

var _TooltipWrapper2 = _interopRequireDefault(_TooltipWrapper);

var _DynamicTooltipSlot = require("./DynamicTooltipSlot");

var _DynamicTooltipSlot2 = _interopRequireDefault(_DynamicTooltipSlot);

var _StaticTooltipSlot = require("./StaticTooltipSlot");

var _StaticTooltipSlot2 = _interopRequireDefault(_StaticTooltipSlot);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // eslint-disable-next-line
// eslint-disable-next-line


var wrapWithClass = function wrapWithClass(Component) {
  var isFunctionalComponent = function isFunctionalComponent(Component) {
    return !Component.prototype.render;
  };

  if (!isFunctionalComponent(Component)) return Component; // eslint-disable-next-line react/prefer-stateless-function

  return function (_React$Component) {
    _inherits(ClassComponent, _React$Component);

    function ClassComponent() {
      _classCallCheck(this, ClassComponent);

      return _possibleConstructorReturn(this, (ClassComponent.__proto__ || Object.getPrototypeOf(ClassComponent)).apply(this, arguments));
    }

    _createClass(ClassComponent, [{
      key: "render",
      value: function render() {
        return _react2.default.createElement(Component, this.props);
      }
    }]);

    return ClassComponent;
  }(_react2.default.Component);
};

var propTypes = {
  tooltip: _propTypes2.default.shape(_Tooltip2.default.propTypes),
  hideTooltipAfter: _propTypes2.default.number
};
var defaultProps = {
  tooltip: _Tooltip2.default.defaultProps
};

var withTooltip = exports.withTooltip = function withTooltip(WrappedComponent) {
  var dontModifyProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // eslint-disable-next-line

  var WithTooltip = function (_Component) {
    _inherits(WithTooltip, _Component); // tooltip container in another component


    function WithTooltip(props) {
      var _this3 = this;

      _classCallCheck(this, WithTooltip);

      var _this2 = _possibleConstructorReturn(this, (WithTooltip.__proto__ || Object.getPrototypeOf(WithTooltip)).call(this, props));

      _this2.state = {
        visible: false,
        ref: null
      };
      _this2._toggleTooltip = _this2.toggleTooltip.bind(_this2);
      _this2._showTooltip = _this2.showTooltip.bind(_this2);
      _this2._hideTooltip = _this2.hideTooltip.bind(_this2);
      _this2._handleRef = _this2._handleRef.bind(_this2);
      _this2._handleVisibleCallback = _this2._handleVisibleCallback.bind(_this2);

      _this2.TooltipSlot = function (props) {
        var mode = _this2.props.mode || 'dynamic';
        return mode === "dynamic" ? _react2.default.createElement(_DynamicTooltipSlot2.default, {
          visible: _this2.state.visible
        }, props.children) : _react2.default.createElement(_StaticTooltipSlot2.default, _extends({
          visible: _this2.state.visible,
          closeOnOutsideClick: _this2.props.closeOnOutsideClick,
          onVisibleCallback: _this2._handleVisibleCallback,
          parent: _this2.state.ref,
          hideTooltip: _this2._hideTooltip
        }, _this2.props), props.children);
      };

      _this2.Tooltip = function (_ref) {
        var children = _ref.children;
        return _react2.default.createElement(_this3.TooltipSlot, null, function (slotProps) {
          return _react2.default.createElement(_TooltipWrapper2.default, slotProps, children);
        });
      };

      _this2.WrappedComponent = wrapWithClass(WrappedComponent);
      return _this2;
    }

    _createClass(WithTooltip, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearHideTimeout();
      }
    }, {
      key: "setHideTimeout",
      value: function setHideTimeout(time) {
        this.tooltipHideTimeout = setTimeout(this._hideTooltip, time);
      }
    }, {
      key: "_handleRef",
      value: function _handleRef(ref) {
        // eslint-disable-next-line
        var targetRef = _reactDom2.default.findDOMNode(ref);

        this.setState({
          ref: targetRef
        });
      }
    }, {
      key: "_handleVisibleCallback",
      value: function _handleVisibleCallback(cb) {
        this.setState({
          visibleCallback: cb
        });
      }
    }, {
      key: "toggleTooltip",
      value: function toggleTooltip(show) {
        var _this4 = this;

        var visible = typeof show === "boolean" ? show : !this.state.visible;
        var hideTooltipAfter = this.props.hideTooltipAfter;
        var visibleCallback = this.state.visibleCallback;
        var cb = !visibleCallback ? function () {} : function () {
          return visibleCallback(_this4.state.visible);
        };
        this.setState({
          visible: visible
        }, cb);

        if (!(0, _reactackleCore.isUndef)(hideTooltipAfter)) {
          if (visible) this.setHideTimeout(hideTooltipAfter);else this.clearHideTimeout();
        }
      }
    }, {
      key: "showTooltip",
      value: function showTooltip() {
        this._toggleTooltip(true);
      }
    }, {
      key: "hideTooltip",
      value: function hideTooltip() {
        this._toggleTooltip(false);
      }
    }, {
      key: "clearHideTimeout",
      value: function clearHideTimeout() {
        clearTimeout(this.tooltipHideTimeout);
      }
    }, {
      key: "render",
      value: function render() {
        var WrappedComponent = this.WrappedComponent;
        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
          ref: this._handleRef,
          toggleTooltip: this._toggleTooltip,
          showTooltip: this._showTooltip,
          hideTooltip: this._hideTooltip,
          Tooltip: this.Tooltip,
          TooltipSlot: this.TooltipSlot,
          isTooltipActive: this.state.visible
        }));
      }
    }]);

    return WithTooltip;
  }(_react.Component);

  WithTooltip.propTypes = _extends({}, WrappedComponent.propTypes, !dontModifyProps ? propTypes : {});
  WithTooltip.defaultProps = _extends({}, WrappedComponent.defaultProps, !dontModifyProps ? defaultProps : {});
  WithTooltip.displayName = "WithTooltip(" + WrappedComponent.displayName + ")";
  ["toggleTooltip", "visible", "hideTooltip", "showTooltip", "isTooltipActive", "Tooltip"].forEach(function (propName) {
    delete WithTooltip.propTypes[propName];
    delete WithTooltip.defaultProps[propName];
  });
  return WithTooltip;
};